import React from 'react'
import { Block, Button, Dialog, Text } from '@mote/ui'
import { WarningIcon } from '@mote/assets/icons'

export const CancellationConfirmationDialog = ({
  switchToPreviousScreen,
  onDialogDismissal
}) => {
  return (
    <Dialog isOpen onClose={onDialogDismissal} hasBackdrop={false}>
      <Dialog.Heading>Cancel Import CSV?</Dialog.Heading>
      <Dialog.Content>
        <Block layout='horizontal' align='center' gap={5}>
          <WarningIcon />
          <Text tag='small'>Are you sure you want to cancel CSV Import?</Text>
        </Block>
      </Dialog.Content>
      <Dialog.ButtonGroup alignment='flex-end' intent='confirmation'>
        <Button
          variant='secondary'
          text='No, Continue'
          size='sm'
          onClick={switchToPreviousScreen}
        />
        <Button text='Cancel Import' size='sm' onClick={onDialogDismissal} />
      </Dialog.ButtonGroup>
    </Dialog>
  )
}
